"use client";

import { useEffect, useState } from "react";
import BillingContent from "../schoolAdmin/Billing/BillingContent";
import TenantPaymentHistory from "../schoolAdmin/Billing/TenantPaymentHistory";
import TenantInvoiceHistory from "../schoolAdmin/Billing/TenantInvoiceHistory";

const MobileBillingApp = () => {
  const [view, setView] = useState("overview");

  // Push a browser history entry per sub-view so the WebView's native
  // canGoBack/goBack (used by the app's hardware-back handler) steps back
  // into "overview" instead of exiting the whole billing screen.
  useEffect(() => {
    const handlePopState = (event) => {
      setView(event.state?.view || "overview");
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const showPayments = () => {
    window.history.pushState({ view: "payments" }, "");
    setView("payments");
  };

  const showInvoices = () => {
    window.history.pushState({ view: "invoices" }, "");
    setView("invoices");
  };

  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-[#ebf3fc] p-4">
      {view === "overview" && (
        <BillingContent
          standalone
          onViewPayments={showPayments}
          onViewInvoices={showInvoices}
        />
      )}
      {view === "payments" && (
        <TenantPaymentHistory standalone onBack={goBack} />
      )}
      {view === "invoices" && (
        <TenantInvoiceHistory standalone onBack={goBack} />
      )}
    </div>
  );
};

export default MobileBillingApp;
